var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{attrs:{"no-body":"","bg-variant":"white","border-variant":"white"}},[_c('p',{staticClass:"mt-3",staticStyle:{"font-weight":"700"}},[_vm._v(" Step "+_vm._s(_vm.instructionsStep)+". "),_c('span',[_vm._v("Schedule your trial with the Judicial Case Manager or as directed by the Judge")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }